class FpHomeHeroSlider {
  constructor(root) {
    this.root = root;
    this.swiperEl = root.querySelector('[data-fp-hero-swiper]');
    this.paginationEl = root.querySelector('[data-fp-hero-pagination]');
    this.swiper = null;
  }

  init() {
    if (!this.swiperEl || this.swiperEl.dataset.fpInitialized === 'true') return;

    this.swiperEl.dataset.fpInitialized = 'true';

    const SwiperConstructor = this.getSwiperConstructor();

    if (!SwiperConstructor) {
      this.waitForSwiper();
      return;
    }

    const slideCount = Number(this.root.dataset.slideCount || 0);
    const autoplayEnabled = this.root.dataset.autoplay === 'true' && slideCount > 1;
    const autoplayDelay = Number(this.root.dataset.autoplaySpeed || 5000);

    this.swiper = new SwiperConstructor(this.swiperEl, {
      slidesPerView: 1,
      loop: slideCount > 1,
      speed: 450,
      watchOverflow: true,
      autoHeight: false,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      pagination: this.paginationEl
        ? {
            el: this.paginationEl,
            clickable: true,
            bulletClass: 'fp-hero-slider__bullet',
            bulletActiveClass: 'fp-hero-slider__bullet--active',
          }
        : false,
    });
  }

  getSwiperConstructor() {
    if (typeof window.Swiper === 'function') return window.Swiper;
    if (window.spratlyTheme && typeof window.spratlyTheme.Swiper === 'function') {
      return window.spratlyTheme.Swiper;
    }

    return null;
  }

  waitForSwiper() {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;

      if (this.getSwiperConstructor()) {
        window.clearInterval(timer);
        this.swiperEl.dataset.fpInitialized = 'false';
        this.init();
      }

      if (attempts > 80) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  destroy() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
    }

    if (this.swiperEl) {
      this.swiperEl.dataset.fpInitialized = 'false';
    }
  }
}

class FpHomeHeroSliderRegistry {
  constructor() {
    this.instances = new Map();
  }

  init(scope = document) {
    scope.querySelectorAll('[data-fp-hero-slider]').forEach((root) => {
      if (this.instances.has(root)) return;

      const instance = new FpHomeHeroSlider(root);
      this.instances.set(root, instance);
      instance.init();
    });
  }

  destroy(sectionId) {
    this.instances.forEach((instance, root) => {
      if (!sectionId || root.dataset.sectionId === sectionId) {
        instance.destroy();
        this.instances.delete(root);
      }
    });
  }
}

window.fpHomeHeroSliderRegistry = window.fpHomeHeroSliderRegistry || new FpHomeHeroSliderRegistry();

document.addEventListener('DOMContentLoaded', () => {
  window.fpHomeHeroSliderRegistry.init();
});

document.addEventListener('shopify:section:load', (event) => {
  window.fpHomeHeroSliderRegistry.init(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  window.fpHomeHeroSliderRegistry.destroy(event.detail.sectionId);
});
